<div class="bg-white rounded-10 p-5 mb-5">
  <div class="flex justify-between gap-2 items-center mb-4">
    <div class="font-roboto-500 text-18 max-sm:text-14">Noticias</div>
    <a>
      <img alt="arrow-right" [src]="urlIcon + 'arrow-right-active.svg'" />
    </a>
  </div>

  <!-- <app-skeleton-trending-news /> -->
  <app-no-result message="Error al cargar Noticias" />
</div>

<div class="flex justify-center max-sm:hidden">
  <div #bannerAds>
    <app-skeleton-banner></app-skeleton-banner>
  </div>
</div>
